import React from 'react';
import { RadioGroup, RadioButton, Card } from 'components';
import { CreateListingCardProps, IncludedExcludedFields } from '../types';
import { StyledGrid } from './StyledComponents';

type IncludedExcludedProps = CreateListingCardProps<IncludedExcludedFields>;

type IncludedExcludedType =
  IncludedExcludedProps['freehold']['included_excluded'];

const IncludedExcluded: React.FC<IncludedExcludedProps> = ({
  freehold: { included_excluded },
  setListing,
}) => {
  const handleChange = (changes: Partial<IncludedExcludedType>) => {
    setListing(prev => ({
      ...prev,
      freehold: {
        included_excluded: {
          ...prev.freehold.included_excluded,
          ...changes,
        },
      },
    }));
  };

  const renderRadioGroup = (
    label: string,
    key: keyof IncludedExcludedType,
    dataCy?: string,
  ) => (
      <RadioGroup
        allowClear
        label={label}
        buttonStyle="solid"
        value={included_excluded[key]}
        onChange={({ target: { value } }) => handleChange({ [key]: value })}
        data-cy={`listing-lease-${dataCy || key}`}
      >
        <RadioButton value="No">No</RadioButton>
        <RadioButton value="Yes">Yes</RadioButton>
      </RadioGroup>
    );

  return (
    <Card type="primary" title="Included / Excluded" id="includedExcluded">
      <StyledGrid $columns={3}>
        {renderRadioGroup('All Inclusive', 'all_inclusive', 'all-inclusive')}
        {renderRadioGroup('Heat Included', 'heat')}
        {renderRadioGroup('Hydro Included', 'hydro')}
        {renderRadioGroup('Water Included', 'water')}
        {renderRadioGroup('Gas Included', 'gas')}
        {renderRadioGroup('Cable TV Included', 'cable')}
        {renderRadioGroup('Phone Included', 'phone')}
        {renderRadioGroup('CAC Included', 'cac')}
      </StyledGrid>
    </Card>
  );
};

export default React.memo(IncludedExcluded);
